// -------------------------------------------------------------------------------
// Libraries
// -------------------------------------------------------------------------------

// -------------------------------------------------------------------------------
// Utils, Styles and Assets
// -------------------------------------------------------------------------------

// -------------------------------------------------------------------------------
// Component
// -------------------------------------------------------------------------------
const TimeIndicator = ({ backgroundColor, left, transition }) => {
  return (
    <div
      style={{
        backgroundColor,
        width: '10px',
        height: '10px',
        position: 'absolute',
        transition,
        left: `calc(${left}% - 5px)`,
        top: 'calc(50% - 5px)',
        borderRadius: '50%',
      }}
    />
  );
};

export default TimeIndicator;
